import {
  GiftCouponShareStatus,
} from '@shared/api/giftCoupon/giftCoupon.interface';
import {
  GiftDeliveryShareStatus,
  GiftDeliveryStatus,
} from '@shared/api/giftDelivery/giftDelivery.interface';

// === 쿠폰 공유 상태 ===

const COUPON_SHARE_STATUS_STYLE: Record<GiftCouponShareStatus, string> = {
  [GiftCouponShareStatus.NotShared]: 'bg-gray-100 text-gray-600',
  [GiftCouponShareStatus.Shared]: 'bg-green-100 text-green-700',
  [GiftCouponShareStatus.Viewed]: 'bg-blue-100 text-blue-700',
};

const COUPON_SHARE_STATUS_LABEL: Record<GiftCouponShareStatus, string> = {
  [GiftCouponShareStatus.NotShared]: '미전달',
  [GiftCouponShareStatus.Shared]: '전달완료',
  [GiftCouponShareStatus.Viewed]: '확인됨',
};

export const getCouponShareStatusStyle = (status: GiftCouponShareStatus) =>
  COUPON_SHARE_STATUS_STYLE[status] ?? 'bg-gray-100 text-gray-600';

export const getCouponShareStatusLabel = (status: GiftCouponShareStatus) =>
  COUPON_SHARE_STATUS_LABEL[status] ?? status;

// === 배송 상태 ===

const DELIVERY_STATUS_STYLE: Record<GiftDeliveryStatus, string> = {
  [GiftDeliveryStatus.WaitingAddress]: 'bg-amber-100 text-amber-700',
  [GiftDeliveryStatus.AddressSubmitted]: 'bg-blue-100 text-blue-700',
  [GiftDeliveryStatus.Preparing]: 'bg-indigo-100 text-indigo-700',
  [GiftDeliveryStatus.Shipping]: 'bg-purple-100 text-purple-700',
  [GiftDeliveryStatus.Delivered]: 'bg-green-100 text-green-700',
  [GiftDeliveryStatus.Canceled]: 'bg-red-100 text-red-700',
};

const DELIVERY_STATUS_LABEL: Record<GiftDeliveryStatus, string> = {
  [GiftDeliveryStatus.WaitingAddress]: '배송지 입력 대기',
  [GiftDeliveryStatus.AddressSubmitted]: '배송지 입력 완료',
  [GiftDeliveryStatus.Preparing]: '상품 준비중',
  [GiftDeliveryStatus.Shipping]: '배송중',
  [GiftDeliveryStatus.Delivered]: '배송 완료',
  [GiftDeliveryStatus.Canceled]: '취소',
};

export const getDeliveryStatusStyle = (status: GiftDeliveryStatus) =>
  DELIVERY_STATUS_STYLE[status] ?? 'bg-gray-100 text-gray-600';

export const getDeliveryStatusLabel = (status: GiftDeliveryStatus) =>
  DELIVERY_STATUS_LABEL[status] ?? status;

// === 배송 공유 상태 ===

const DELIVERY_SHARE_STATUS_STYLE: Record<GiftDeliveryShareStatus, string> = {
  [GiftDeliveryShareStatus.NotShared]: 'bg-gray-100 text-gray-600',
  [GiftDeliveryShareStatus.Shared]: 'bg-green-100 text-green-700',
  [GiftDeliveryShareStatus.Viewed]: 'bg-blue-100 text-blue-700',
};

const DELIVERY_SHARE_STATUS_LABEL: Record<GiftDeliveryShareStatus, string> = {
  [GiftDeliveryShareStatus.NotShared]: '미전달',
  [GiftDeliveryShareStatus.Shared]: '전달완료',
  [GiftDeliveryShareStatus.Viewed]: '확인됨',
};

export const getDeliveryShareStatusStyle = (status: GiftDeliveryShareStatus) =>
  DELIVERY_SHARE_STATUS_STYLE[status] ?? 'bg-gray-100 text-gray-600';

export const getDeliveryShareStatusLabel = (status: GiftDeliveryShareStatus) =>
  DELIVERY_SHARE_STATUS_LABEL[status] ?? status;

export const SHARE_GUIDE_DISMISSED_KEY = 'gift-coupon-share-guide-dismissed';
